import Vue from 'vue'
import * as types from '../../types'

const state = {
    item: null
}

const getters = {
    [types.invitations.modules.current.getters.item]: state => state.item
}

const actions = {}

const mutations = {
    [types.invitations.modules.current.mutations.found] (state, payload) {
        Vue.set(state, 'item', payload.item)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
